@if (businessUnitId(); as buId) { @if (buRes.error()) {
<div class="p-6" role="alert">
  <p>{{ 'membership-data-unavailable' | transloco }}</p>
  <button mat-stroked-button type="button" (click)="buRes.reload()">{{ 'membership-retry' | transloco }}</button>
</div>
} @else {
<div class="flex max-h-full overflow-auto invisibleScrollBar h-full flex-col">
  <!-- Header -->
  <div class="border-b border-outlineVariant bg-surface p-6">
    @if (buRes.isLoading()) {
    <mat-progress-spinner mode="indeterminate" diameter="24" />
    } @else if (buRes.value(); as bu) {
    <div class="mb-4 flex items-start justify-between">
      <div class="flex-1">
        <h1 class="text-headline-small mb-2">{{ bu.name }}</h1>

        <div class="text-body-medium text-onSurfaceVariant flex items-center gap-2">
          <p class="text-body-large">{{ bu.description }}</p>
        </div>
      </div>

      <!-- Action Buttons -->
      <div class="flex gap-2">
        <button mat-stroked-button type="button" (click)="openEditBusinessUnitDialog()" [matTooltip]="'edit' | transloco">
          {{ 'edit' | transloco }}
        </button>
        <button mat-stroked-button type="button" class="text-error!" (click)="delete.emit(bu.identifier)">
          {{ 'delete' | transloco }}
        </button>
      </div>
    </div>
    }
  </div>

  <!-- Tabs Content -->
  @if (!buRes.isLoading() && !membershipUsers()) {
  <p class="p-6 text-error" role="alert">{{ 'membership-data-unavailable' | transloco }}</p>
  }
  <mat-tab-group [selectedIndex]="selectedTabIndex()" (selectedIndexChange)="onTabChange($event)">
    <!-- General Tab -->
    <mat-tab>
      <ng-template mat-tab-label> {{ 'general' | transloco }} </ng-template>
      @if (buRes.value(); as bu) {
      <dtis-admin-business-unit-general-tab [businessUnit]="bu" [masterCount]="getCountByType('Master')" [instanceCount]="getCountByType('Instance')" />
      }
    </mat-tab>

    <!-- Administrators Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        {{ 'administrators' | transloco }}
      </ng-template>
      <dtis-admin-business-unit-users-tab
        [users]="usersByRole()['Administrator'] || []"
        [currentUsername]="currentUsername()"
        [allUsers]="membershipUsers()"
        [isChanging]="membershipChanging()"
        [title]="'administrators'"
        [addButtonLabel]="'add-administrator'"
        [emptyMessage]="'no-administrators-assigned'"
        [filterPlaceholder]="'filter-administrators'"
        (addUser)="openUserSearchDialog('Administrator')"
        (removeUser)="removeUser($event)"
      />
    </mat-tab>

    <!-- Users Tab -->
    <mat-tab>
      <ng-template mat-tab-label> {{ 'users' | transloco }} </ng-template>
      <dtis-admin-business-unit-users-tab
        [users]="usersByRole()['User'] || []"
        [currentUsername]="currentUsername()"
        [allUsers]="membershipUsers()"
        [isChanging]="membershipChanging()"
        [title]="'users'"
        [addButtonLabel]="'add-user'"
        [emptyMessage]="'no-users-assigned'"
        [filterPlaceholder]="'filter-users'"
        (addUser)="openUserSearchDialog('User')"
        (removeUser)="removeUser($event)"
      />
    </mat-tab>

    <!-- Organizational Structure Tab -->
    <mat-tab>
      <ng-template mat-tab-label>
        {{ 'organizational-structure' | transloco }}
      </ng-template>
      @if (rootItem.error()) {
      <div class="flex flex-col items-center justify-center gap-4 p-8 text-center" role="alert">
        <mat-icon class="h-10! w-10! text-[40px]! text-error">error_outline</mat-icon>
        <p class="text-body-medium text-onSurfaceVariant">Failed to load organizational structure. Please try again.</p>
        <button mat-stroked-button type="button" (click)="rootItem.reload()">
          <mat-icon>refresh</mat-icon>
          Retry
        </button>
      </div>
      } @else {
      <dtis-admin-business-unit-organizational-structure-tab
        [rootItem]="rootItem.value() ?? null"
        [isLoading]="rootItem.isLoading()"
        [isAdmin]="isAdmin()"
        (createChild)="createChildItem($event)"
        (deleteItem)="deleteOrganizationItem()"
      />
      }
    </mat-tab>
  </mat-tab-group>
</div>
} } @else {
<div class="flex h-full items-center justify-center">
  <div class="text-center">
    <mat-icon class="h-16! w-16! text-[64px] text-onSurfaceVariant mb-4">business</mat-icon>
    <h2 class="text-title-large text-onSurfaceVariant">
      {{ 'select-business-unit' | transloco }}
    </h2>
    <p class="text-body-medium text-onSurfaceVariant mt-2">
      {{ 'select-business-unit-hint' | transloco }}
    </p>
  </div>
</div>
}
